import 'dayjs/locale/ko';
import { toSmartScheduleKst } from '@/features/smartSchedule/date';
import { NoticeStatus } from './types';

// 서버 ISO 시각과 기존 날짜 전용/오프셋 없는 값을 허용한다.
const NOTICE_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,3})?)?(Z|[+-]\d{2}:?\d{2})?)?$/i;

export const formatNoticeDate = (
    notice: {
        status: NoticeStatus;
        publishAt?: string | null;
        publishedAt?: string | null;
        createdAt?: string | null;
    },
    format = 'YYYY-MM-DD(dd) H:mm',
) => {
    const date =
        notice.status === 'scheduled'
            ? notice.publishAt
            : notice.status === 'published' && notice.publishedAt
              ? notice.publishedAt
              : notice.createdAt;

    // 예약 시각은 생성일로 대체하지 않는다. dayjs(undefined)는 현재 시각이므로 파싱 전에 확인한다.
    if (typeof date !== 'string' || !date.trim()) return '-';
    const value = date.trim();
    const parts = NOTICE_DATE_PATTERN.exec(value);
    if (!parts) return '-';
    const [, year, month, day, hour = '00', minute = '00', second = '00', offset] = parts;
    // Date/dayjs가 2월 30일 등을 다음 달로 정규화해도 원래 연월일과 비교해 거부한다.
    const calendarDate = new Date(`${year}-${month}-${day}T00:00:00.000Z`);
    if (
        calendarDate.getUTCFullYear() !== Number(year) ||
        calendarDate.getUTCMonth() + 1 !== Number(month) ||
        calendarDate.getUTCDate() !== Number(day) ||
        Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59
    ) return '-';
    if (offset && offset.toUpperCase() !== 'Z') {
        const digits = offset.slice(1).replace(':', '');
        if (Number(digits.slice(0, 2)) > 23 || Number(digits.slice(2)) > 59) return '-';
    }

    try {
        const parsed = toSmartScheduleKst(value).locale('ko');
        if (!parsed.isValid()) return '-';
        const formatted = parsed.format(format);
        return notice.status === 'scheduled' ? `${formatted} 예약` : formatted;
    } catch {
        return '-';
    }
};
